/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_PAYMENT_TYPE = 'ADD_LOCAL_PAYMENT_TYPE';
export const REMOVE_LOCAL_PAYMENT_TYPE = 'REMOVE_LOCAL_PAYMENT_TYPE';
export const API_LOAD_PAYMENT_TYPES = 'API_LOAD_PAYMENT_TYPES';
export const API_REMOVE_PAYMENT_TYPE = 'API_REMOVE_PAYMENT_TYPE';
export const API_CREATE_PAYMENT_TYPE = 'API_CREATE_PAYMENT_TYPE';
export const API_UPDATE_PAYMENT_TYPE = 'API_UPDATE_PAYMENT_TYPE';

const API_LOAD_PAYMENT_TYPES_FAILED = 'API_LOAD_PAYMENT_TYPES_FAILED';
const API_LOAD_PAYMENT_TYPES_LOADING = 'API_LOAD_PAYMENT_TYPES_LOADING';
const API_LOAD_PAYMENT_TYPES_LOADED = 'API_LOAD_PAYMENT_TYPES_LOADED';
const API_REMOVE_PAYMENT_TYPE_FAILED = 'API_REMOVE_PAYMENT_TYPE_FAILED';
const API_REMOVE_PAYMENT_TYPE_LOADING = 'API_REMOVE_PAYMENT_TYPE_LOADING';
const API_REMOVE_PAYMENT_TYPE_SUCCESS = 'API_REMOVE_PAYMENT_TYPE_SUCCESS';
const API_CREATE_PAYMENT_TYPE_FAILED = 'API_CREATE_PAYMENT_TYPE_FAILED';
const API_CREATE_PAYMENT_TYPE_LOADING = 'API_CREATE_PAYMENT_TYPE_LOADING';
const API_CREATE_PAYMENT_TYPE_SUCCESS = 'API_CREATE_PAYMENT_TYPE_SUCCESS';

const defaultState = { paymentTypes: [], loading: false };
const emptyPaymentType = () => ({ id: getId(), name: '', vendor_needed: false, isRemoving: false });
const mapDefaults = paymentType => ({ ...emptyPaymentType(), ...paymentType });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_PAYMENT_TYPES_LOADED:
      return update(state, {
        loading: { $set: false },
        paymentTypes: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_PAYMENT_TYPES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_PAYMENT_TYPES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_PAYMENT_TYPE:
      return update(state, { paymentTypes: { $push: [emptyPaymentType()] } });
    case API_REMOVE_PAYMENT_TYPE_SUCCESS:
    case REMOVE_LOCAL_PAYMENT_TYPE:
      return update(state, { paymentTypes: { $splice: [[indexById(id, state.paymentTypes), 1]] } });
    case API_REMOVE_PAYMENT_TYPE_FAILED:
      return update(state, { paymentTypes: { [indexById(id, state.paymentTypes)]: { removing: { $set: false } } } });
    case API_REMOVE_PAYMENT_TYPE_LOADING:
      return update(state, { paymentTypes: { [indexById(id, state.paymentTypes)]: { removing: { $set: true } } } });
    case API_CREATE_PAYMENT_TYPE_FAILED:
      return update(state, { paymentTypes: { [indexById(resource.id, state.paymentTypes)]: { saving: { $set: false } } } });
    case API_CREATE_PAYMENT_TYPE_LOADING:
      return update(state, { paymentTypes: { [indexById(resource.id, state.paymentTypes)]: { saving: { $set: true } } } });
    case API_CREATE_PAYMENT_TYPE_SUCCESS:
      return update(state, { paymentTypes: { $splice: [[indexById(replaceId, state.paymentTypes), 1, response]] } });
    default:
      return state;
  }
};

export const paymentTypes = state => state.paymentTypes.paymentTypes.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const loading = state => state.paymentTypes.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/paymentTypes/paymentTypes.reducer.js